import React from 'react';
import  {Tooltip, Button, Dialog, Classes, Intent, Icon}  from "@blueprintjs/core";

function TransferDialog(props) {
    const transferTo = (agent) => {
      props.setAgentToConversation(props.currentConversation, agent)
      props.closeTransferDialog()
    }
    return (
        <Dialog
            icon="exchange"
            onClose={props.closeTransferDialog}
            title='Transferir contacto'
            isOpen= {props.transferDialogIsOpen}>
            <div className={Classes.DIALOG_BODY}>
                <p>
                    <strong>
                        Selecciona el agente o grupo de agentes para transferirle el chat
                    </strong>
                </p>
                <table className="bp3-html-table" style={{width: "100%"}} >

                  <>
                    
                  <RenderAgents
                    transferTo={transferTo}
                    agentList={props.agentList} />
                  </>
                </table>                        
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Tooltip content="Cierra el recuadro sin reasignar.">
                        <Button onClick={props.closeTransferDialog}>Cancelar</Button>
                    </Tooltip>
                </div>
            </div>
        </Dialog>

    )
}

function RenderAgents(props) {

  const sortedContacts = props.agentList.sort((a, b) => a.group > b.group ? 1 : -1);
  let prevGroup=".";
  //let groupName=""
  return sortedContacts.map(function(agent) {
    let icon="blocked-person";
    let intent=Intent.DANGER;
    if(agent.connected){
      icon="follower";
      intent=Intent.SUCCESS;
    }
    if(prevGroup!==agent.group){
      prevGroup=agent.group;
      return (
        <tbody key={'tbody-'+prevGroup}>
            <tr key={'tr-'+prevGroup} onClick={props.transferTo.bind(this, prevGroup)}>
              <th >Grupo: {agent.group}</th>
              <td> 
              <Tooltip content="Asignar al grupo">
              <Icon icon="inherited-group" iconSize="30" intent={Intent.SUCCESS} /> 
              </Tooltip> 
              </td>
            </tr>

            <tr key={'atr-'+agent.email} onClick={props.transferTo.bind(this, agent.email)}>
              
              <td style={{textTransform: "capitalize"}}><img className="img-fluid rounded-circle mr-2" style={{height:"50px", cursor:"pointer"}} src={agent.picture} alt="N/A"></img> {agent.name}</td>
              <td>
              <Tooltip content="Asignar al agente">
              <Icon icon={icon} iconSize="30" intent={intent} />
              </Tooltip>
              </td>
            </tr>
            </tbody>
        )
    }

    return(
      <tbody key={'tbody-'+agent.email}>
        <tr key={'tr-'+agent.email} onClick={props.transferTo.bind(this, agent.email)}>
          
          <td style={{textTransform: "capitalize"}}><img className="img-fluid rounded-circle mr-2" style={{height:"50px", cursor:"pointer"}} src={agent.picture} alt="N/A"></img> {agent.name}</td>
          <td>
          <Tooltip content="Asignar al agente">
          <Icon icon={icon} iconSize="30" intent={intent} />
          </Tooltip>
          </td>
        </tr>
        </tbody>
      )
  })
}


export default TransferDialog;
